<template>
  <div class="main-wrapper">
    <div v-if="sidebarOpen && sidebarNeeded" class="sidebar-container">
      <Sidebar
        :open="sidebarOpen"
        :projects="sidebarProjectsList"
        :incoming-projects="incomingProjects"
        @changeCompany="changeCompany"
      />
      <div class="help spacey-8">
        <button class="help__link" @click="openSupportChat">
          <Icon
            class="help__icon pointer no-outline"
            type="message-filled"
            color="secondary"
            size="16"
          />
          {{ $t('Open chat') }}
        </button>
        <a class="help__link" href="https://help.fixtender.com" target="_blank">
          <Icon class="help__icon pointer no-outline" type="help" color="secondary" size="16" />
          {{ $t('Help & Feedback') }}
        </a>
      </div>
    </div>

    <div :class="classname" class="section">
      <slot />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import Sidebar from '@/components/sidebar/Sidebar';
  import { openSupportChat } from '@/integrations';
  import sidebarProjects from '@/store/sidebar-projects';
  import { addModule } from '@/store';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'SidebarLayout',
    components: {
      Sidebar,
      Icon,
    },
    props: {
      classname: String,
      sidebarNeeded: {
        type: Boolean,
        default: true,
      },
      noQuery: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState({
        sidebarOpen: (state) => state.global.sidebarOpen,
        incomingProjects: (state) => state.sidebarProjects.incomingTenders,
        sidebarProjectsList: (state) => state.sidebarProjects.sidebarProjectsList,
      }),
    },
    methods: {
      openSupportChat,
      ...mapActions('sidebarProjects', ['loadIncomingTenders', 'loadSidebarProjectsList']),
      changeCompany(id) {
        this.$apollo.queries.projects.refetch({ team: id });
      },
    },
    async created() {
      addModule('sidebarProjects', sidebarProjects);
      // Данные запросы актуализируют списки проектов
      // в сайдбаре при каждой смене корневого урла (апдейте layout-а)
      await this.loadSidebarProjectsList();
      await this.loadIncomingTenders();
    },
  };
</script>

<style lang="scss" scoped>
  .help {
    padding: 12px;
    box-shadow: inset -1px 0px 0px #dadde2;
    display: flex;
    flex-direction: column;

    &__icon {
      max-width: 16px;
      margin-right: 9px;
    }

    &__link {
      display: flex;
      color: #7e8186;
      font-weight: 500;
      font-size: 14px;
      text-decoration: none;
      padding: 6px 8px;
      align-items: center;
      cursor: pointer;

      &:hover {
        color: #585a5f;
      }
    }
  }
  .main-wrapper {
    display: flex;
    overflow-y: hidden;
  }
</style>
